/**
 * Generic canvas surface.
 *
 * The engine renderer is deliberately game-agnostic: it owns the 2D context
 * and offers a background clear. All OVERVOLT-specific drawing lives in
 * `game/render.ts`, which reads game state and never mutates it.
 */
export class Renderer {
  private readonly ctx: CanvasRenderingContext2D;

  constructor(private readonly canvas: HTMLCanvasElement) {
    const ctx = canvas.getContext('2d');
    if (!ctx) {
      throw new Error('[Renderer] 2D canvas context unavailable');
    }
    this.ctx = ctx;
  }

  /** The raw 2D context, handed to the game/HUD draw layers. */
  get context(): CanvasRenderingContext2D {
    return this.ctx;
  }

  /** Canvas width in logical pixels. */
  get width(): number {
    return this.canvas.width;
  }

  /** Canvas height in logical pixels. */
  get height(): number {
    return this.canvas.height;
  }

  /** Paint the whole canvas with a solid background color. */
  clear(color: string): void {
    this.ctx.fillStyle = color;
    this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
  }
}
